import { Link } from 'react-router-dom';

const cases = [
  {
    id: 1,
    category: '美容保養',
    title: '生髮、黑髮果凍條產品',
    desc: '針對頭髮健康需求，開發天然植萃機能果凍條',
    img: 'https://readdy.ai/api/search-image?query=hair%20health%20beauty%20supplement%20jelly%20stick%20product%20with%20natural%20plant%20extract%20black%20sesame%20ginger%20ingredients%20on%20clean%20white%20background%20elegant%20packaging%2C%20professional%20product%20photography&width=600&height=400&seq=case-hair-01&orientation=landscape',
    tags: ['案例 01'],
  },
  {
    id: 2,
    category: '寵物保健',
    title: '國內外寵物保健品系列',
    desc: '符合飼料添加法規，為毛孩打造天然機能保健品',
    img: 'https://readdy.ai/api/search-image?query=pet%20health%20supplement%20products%20natural%20organic%20dog%20cat%20vitamins%20treats%20on%20light%20background%2C%20cute%20animal%20care%20products%20with%20herbs%20botanical%20ingredients%2C%20professional%20product%20photography&width=600&height=400&seq=case-pet-02&orientation=landscape',
    tags: ['案例 02'],
  },
  {
    id: 3,
    category: '兒童營養',
    title: '兒童營養補充粉劑',
    desc: '針對兒童營養需求，開發天然、成分安全的粉末補充品',
    img: 'https://readdy.ai/api/search-image?query=children%20health%20supplement%20powder%20nutrition%20stick%20packet%20colorful%20fruit%20flavored%20with%20vitamins%20minerals%20on%20white%20background%2C%20kids%20health%20food%20product%20photography&width=600&height=400&seq=case-kids-01&orientation=landscape',
    tags: ['案例 03'],
  },
];

export default function ProductCasesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            代工案例
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            多元產品，成功案例豐富
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技服務橫跨多個產品類別，以下為部分代表性代工案例
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((c) => (
            <Link
              key={c.title}
              to={`/about/cases#case-${c.id}`}
              className="bg-[#f7faf7] rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 transition-all duration-300 group cursor-pointer block"
            >
              <div className="w-full h-[220px] overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <span className="inline-block bg-green-100 text-[#4CAF50] text-[0.75rem] font-medium px-3 py-1 rounded-full mb-3">
                  {c.category}
                </span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{c.title}</h3>
                <p className="text-gray-500 text-[0.875rem] leading-[1.75] mb-4">{c.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {c.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-white border border-gray-200 text-gray-500 text-[0.75rem] px-3 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/about/cases"
            className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1rem] px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
          >
            查看更多成功案例
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}